import React from 'react';
import { HowMainSection } from './sections/how/Main';
import { HowStepOne } from './sections/how/Step1';
import { HowStepTwo } from './sections/how/Step2';
import { HowStepThree } from './sections/how/Step3';
import { ToolsMainSection } from './sections/tools/Main';
import { ToolsStepOne } from './sections/tools/Step1';
import { ToolsStepTwo } from './sections/tools/Step2';
import { ToolsStepThree } from './sections/tools/Step3';
import { ToolsStepFour } from './sections/tools/Step4';
import { ToolsStepFive } from './sections/tools/Step5';
import { SecureMainSection } from './sections/secure/Main';
import { SecureStepOne } from './sections/secure/Step1';
import { SecureStepTwo } from './sections/secure/Step2';
import { SecureStepThree } from './sections/secure/Step3';
import { SecureStepFour } from './sections/secure/Step4';
import { GuideMainSection } from './sections/guide/Main';
import { GuideStepOne } from './sections/guide/Step1';
import { GuideStepTwo } from './sections/guide/Step2';
import { GuideStepThree } from './sections/guide/Step3';
import { GuideStepFour } from './sections/guide/Step4';

export const SectionSelector = ({ currentSection }) => {
  switch (currentSection) {
    case 'how':
      return <HowMainSection />;
    case 'how_1':
      return <HowStepOne />;
    case 'how_2':
      return <HowStepTwo />;
    case 'how_3':
      return <HowStepThree />;

    case 'tools':
      return <ToolsMainSection />;
    case 'tools_1':
      return <ToolsStepOne />;
    case 'tools_2':
      return <ToolsStepTwo />;
    case 'tools_3':
      return <ToolsStepThree />;
    case 'tools_4':
      return <ToolsStepFour />;
    case 'tools_5':
      return <ToolsStepFive />;

    case 'secure':
      return <SecureMainSection />;
    case 'secure_1':
      return <SecureStepOne />;
    case 'secure_2':
      return <SecureStepTwo />;
    case 'secure_3':
      return <SecureStepThree />;
    case 'secure_4':
      return <SecureStepFour />;

    case 'guide':
      return <GuideMainSection />;
    case 'guide_1':
      return <GuideStepOne />;
    case 'guide_2':
      return <GuideStepTwo />;
    case 'guide_3':
      return <GuideStepThree />;
    case 'guide_4':
      return <GuideStepFour />;

    default:
      return null;
  }
};
